import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { OpportunitySection } from './components/OpportunitySection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { AddOnSection } from './components/AddOnSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-[#FAFAF9]" data-id="element-0">
      <Hero data-id="element-1" />
      {/* Wave transition */}
      <div className="relative -mt-24" data-id="element-2">
        <svg className="w-full h-24" preserveAspectRatio="none" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3">
          <path d="M0,64 C240,96 480,96 720,64 C960,32 1200,32 1440,64 L1440,120 L0,120 Z" fill="white" data-id="element-4" />
        </svg>
        <ProblemSection data-id="element-5" />
      </div>
      {/* Angled transition */}
      <div className="relative" data-id="element-6">
        <div className="absolute top-0 left-0 right-0 overflow-hidden" data-id="element-7">
          <div className="h-24 bg-white transform -skew-y-2 origin-top-left" data-id="element-8"></div>
        </div>
        <OpportunitySection data-id="element-9" />
      </div>
      {/* Curved transition */}
      <div className="relative -mt-16" data-id="element-10">
        <svg className="w-full h-32" preserveAspectRatio="none" viewBox="0 0 1440 160" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-11">
          <path d="M0,80 Q360,0 720,80 T1440,80 L1440,160 L0,160 Z" fill="white" data-id="element-12" />
        </svg>
        <HowItWorksSection data-id="element-13" />
      </div>
      {/* Diagonal transition */}
      <div className="relative" data-id="element-14">
        <div className="absolute top-0 left-0 right-0 overflow-hidden h-20" data-id="element-15">
          <div className="h-40 bg-white transform skew-y-2 origin-bottom-right" data-id="element-16"></div>
        </div>
        <AddOnSection data-id="element-17" />
      </div>
      {/* Final wave transition */}
      <div className="relative -mt-12" data-id="element-18">
        <svg className="w-full h-24" preserveAspectRatio="none" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-19">
          <path d="M0,40 C320,80 640,80 960,40 C1280,0 1440,0 1440,40 L1440,120 L0,120 Z" fill="white" data-id="element-20" />
        </svg>
        <Footer data-id="element-21" />
      </div>
    </div>;
}